import type { ScrollMapPoint } from '@gem-sdk/heatmap-react';

import { MOCK_HEATMAP_SCROLL_ATTENTIONS } from './heatmap-scroll-attentions';
import { MOCK_HEATMAP_SCROLL_DEPTH } from './heatmap-scroll-depth';
import { EScrollType } from '@gem-sdk/heatmap-react';

export const MOCK_HEATMAP_BY_TYPE: Record<EScrollType, ScrollMapPoint[]> = {
  [EScrollType.Depth]: MOCK_HEATMAP_SCROLL_DEPTH,
  [EScrollType.Attention]: MOCK_HEATMAP_SCROLL_ATTENTIONS,
  [EScrollType.Revenue]: MOCK_HEATMAP_SCROLL_ATTENTIONS,
};
